/*eslint no-magic-numbers: 0*/
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

// scss
import "./StartingSteps.scss";

class StartingSteps extends Component {
  renderSteps(progress) {
    const titles = [
      this.props.isTeam360 ? "Set up Your Stakeholders" : "Set up Your Team",
      "Await Questionnaire Result",
      "View Your Summary Report"
    ];

    return progress.map((step, key) => {
      return (
        <Fragment key={key}>
          <li>
            <div className={`node ${step.color}`}>
              <span className="step">{step.order}</span>
            </div>
            <p>{titles[key]}</p>
          </li>
          {step.order !== 3 && (
            <li>
              <div className={`divider ${step.state ? "green" : "grey"}`} />
            </li>
          )}
        </Fragment>
      );
    });
  }

  render() {
    const { isFullReport, isTeam360, progress } = this.props;
    return (
      <Fragment>
        <div className="steps-parent">
          <div className="steps-container">
            <div className="steps-container__tree">
              <div className="pad">
                <span>
                  Getting Started with TeamLytica
                  {isTeam360 ? " Team 360 Report" : " Free Summary Report"}
                </span>
              </div>
              <ol id="progress">{this.renderSteps(progress)}</ol>
            </div>
            <div className="steps-container__actions">
              {progress[0] && !progress[0].state && (
                <div className="btn-wrapper">
                  <span className="text">
                    Let&apos;s get your {isTeam360 ? "Stakeholders" : "Team"}{" "}
                    set up and your
                    <br />
                    TeamLytica Questionnaires sent out...
                  </span>
                  <Link
                    to={isTeam360 ? "/stakeholders" : "/team"}
                    className="team-btn"
                  >
                    <span>
                      Set up Your {isTeam360 ? "Stakeholders" : "Team"}
                    </span>
                    <i className="fas fa-chevron-right" />
                  </Link>
                </div>
              )}
              {!isTeam360 && !isFullReport && (
                <div className="btn-wrapper">
                  <span className="text">
                    Our Reports give you greater insight into
                    <br />
                    your team&apos;s performance and cohesion
                  </span>
                  <Link className="upgrade-btn" to={`/product/full-report`}>
                    <i className="fas fa-chart-pie" />
                    <span>Upgrade to Full Report</span>
                    <i className="fas fa-chevron-right" />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="steps-footer">
          <Link to="/explainer-videos" className="help-vid">
            <div className="help-vid-title">
              <i className="fa fa-play-circle orange" />
              <span className="help-title">Help Videos</span>
            </div>
            <div className="help-info-wrapper">
              <span className="help-info">
                We&apos;ve created a few helpful videos showing some of the
                features of the powerful toolset available
              </span>
              <i className="fas fa-chevron-right orange" />
            </div>
          </Link>
          <a
            className="help-vid"
            target="__blank"
            href="https://calendly.com/teamlytica/consulting-hour"
          >
            <div className="help-vid-title">
              <i className="fa fa-comment yellow" />
              <span className="help-title">Contact Support</span>
            </div>
            <div className="help-info-wrapper">
              <span className="help-info">
                Click here to contact us for some support or advice on using
                TeamLytica
              </span>
              <i className="fas fa-chevron-right yellow" />
            </div>
          </a>
        </div>
      </Fragment>
    );
  }
}

StartingSteps.propTypes = {
  isFullReport: PropTypes.bool,
  isTeam360: PropTypes.bool,
  setNavigationAssets: PropTypes.func,
  progress: PropTypes.array,
  firstName: PropTypes.string,
  userPlan: PropTypes.string
};

export default StartingSteps;
